<template>
  <div v-if="ordersList.length > 0" class="orders-table" :class="[{na: not_available}]">
    <div class="col head number"><span>Номер заказа</span></div>
    <div class="col head"><span>Дата</span></div>
    <div class="col head"><span>Статус</span></div>
    <div class="col head"><span>Кол-во</span></div>
    <div class="col head" :class="[{last: not_available}]"><span>Цена</span></div>
    <div class="col head last" v-if="!not_available"><span></span></div>

    <template v-for="order in ordersList" :key="order">
      <div class="col val number"
           @click="function() {$router.push(
                    {
                        name:'order_detail',
                        params: {order_id: order.id}
                    }
                    )}"
           @mouseenter="hover_item(order.id, true)" @mouseleave="hover_item(order.id, false)"
           :class="['item_'+ order.id]"><span class="m_desc">Номер заказа</span><span>№{{order.id}}</span></div>
      <div class="col val"
           @click="function() {$router.push(
                    {
                        name:'order_detail',
                        params: {order_id: order.id}
                    }
                    )}"
           @mouseenter="hover_item(order.id, true)" @mouseleave="hover_item(order.id, false)"
           :class="['item_'+ order.id]"><span class="m_desc">Дата</span><span>{{order.date}}</span></div>
      <div class="col val status"
           @click="function() {$router.push(
                    {
                        name:'order_detail',
                        params: {order_id: order.id}
                    }
                    )}"
           @mouseenter="hover_item(order.id, true)" @mouseleave="hover_item(order.id, false)"
           :class="[order.status_color, 'item_'+ order.id]"><span class="m_desc">Статус</span><span>{{order.status_text}}</span></div>
      <div class="col val"
           @click="function() {$router.push(
                    {
                        name:'order_detail',
                        params: {order_id: order.id}
                    }
                    )}"
           @mouseenter="hover_item(order.id, true)" @mouseleave="hover_item(order.id, false)"
           :class="['item_'+ order.id]"><span class="m_desc">Кол-во</span><span>{{order.quantity}} шт</span></div>
      <div class="col val"
           @click="function() {$router.push(
                    {
                        name:'order_detail',
                        params: {order_id: order.id}
                    }
                    )}"
           @mouseenter="hover_item(order.id, true)" @mouseleave="hover_item(order.id, false)"
           :class="[{last: not_available}, 'item_'+ order.id]"><span class="m_desc">Цена</span><span>{{order.price}}</span></div>
      <div class="col val last buttons"
           @mouseenter="hover_item(order.id, true)" @mouseleave="hover_item(order.id, false)"
           :class="['item_'+ order.id]" v-if="!not_available">
        <standart-button @click="repeat(order.id)" text="Повторить"></standart-button>
        <standart-button v-show="order.status_color != 'cancelled'" @click="cancel(order.id)" style_type="danger" text="Отменить"></standart-button>
      </div>
    </template>
  </div>
</template>

<script>
import StandartButton from "@/components/share/StandartButton";
import axios from "axios";

export default {
  name: 'OrdersTable',
  props : {
    not_available : Boolean
  },
  components: {
    StandartButton
  },
  data() {
    return{
      ordersList : []
    }
  },
  mounted() {

  },
  methods : {
    hover_item : function(order_id, enter) {
      let row = document.querySelectorAll('.orders-table .item_' + order_id);
      for (var i = 0; i < row.length; ++i) {
        if(enter) {row[i].classList.add('hover');}
        else {row[i].classList.remove('hover');}
      }
    },
    repeat : async function(order_id) {
      console.log("Повтор заказа: " + order_id);
      await axios.get(window.api_url + "order/repeat?api=y&id="+order_id+"&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");
      this.$router.push({name:'basket'});
    },
    cancel : async function(order_id) {
      let conf = confirm("Вы уверены что хотите отменить заказ №" + order_id + "?");
      if(conf) {
        console.log("Отмена заказа: " + order_id);
        await axios.get(window.api_url + "order/cancel?api=y&id="+order_id+"&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");
        window.location.reload();
      }
    }
  }
}
</script>

<style scoped>

.orders-table {
  width: 100%;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  box-sizing: border-box;
  border-radius: 8px;
  display: grid;
  grid-template-columns: min-content auto auto auto auto 290px;
}

.orders-table.na {
  grid-template-columns: min-content auto auto auto auto;
}

.col {
  padding: 14px 20px;
  text-align: center;
}

.col.head.number, .col.val.number {
  text-align: start;
  justify-content: start;
  white-space: nowrap;
}

.col.buttons {
  display: flex;
  gap: 10px;
}

.col.head {
  border-right: 1px solid var(--Border, #EDEDED);
}
.col.head.last {
  border-right: unset;
}

.col.head span{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.col.val {
  border-top: 1px solid var(--Border, #EDEDED);
  display: flex;
  align-items: center;
  justify-content: center;
}

.col.val.last {
  border-right: unset;
}

.col.val span{
  color: var(--Black, #222);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.col.val.hover {
  background: var(--BG, #F8F8F8);
}

.col.val.status.wait_payment span {
  color: var(--Blue, #1B78BC);
}

.col.val.status.new span {
  color: var(--Green, #69BE15);
}

.col.val.status.cancelled span {
  color: var(--Red, #FA4B61);
}

.col.val.status.in_processing span {
  color: #F58646;
}

.col.val.status.sent span {
  color: var(--Black, #222);
}

.col.val.status.completed span {
  color: var(--Green, #69BE15);
}

.col.val.status.paid span {
  color: var(--Gray, #656565);
}

.col.val.status.return span {
  color: var(--Red, #FA4B61);
}



.m_desc {
  display: none;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .orders-table, .orders-table.na {
    grid-template-columns: auto;
  }

  .col.head {
    display: none;
  }

  .col.val, .col.val.number {
    border-top: unset;
    justify-content: space-between;
    padding: 0px 18px 12px 18px;
  }

  .col.val.number {
    padding: 18px 18px 12px 18px;
  }

  .col.val.last {
    border-bottom: 1px solid var(--Border, #EDEDED);
    padding: 6px 18px 18px 18px;
  }

  .col.val.last:last-child {
    border-bottom: unset;
  }

  .col.val span.m_desc, .col.val.status span.m_desc {
    display: block;
    color: var(--Gray, #656565);
    font-size: 14px;
  }

  .col.val span {
    font-size: 14px;
  }

}
</style>



<style>

.col.buttons .standart_button {
  height: 38px;
  width: 120px;
}



/*MOBILE*/
@media (max-width: 1250px)
{

}

</style>
